import type React from 'react';
import { Link } from 'react-router-dom';
import { classNames } from '@/lib/utils';
import type { AuthFormLayoutProps } from './AuthFormLayout.types';

export const AuthFormLayout: React.FC<AuthFormLayoutProps> = ({ title, children, error, footer, className = '' }) => {
  return (
    <div
      className={classNames('flex w-1/2 p-16 flex-col justify-center items-center bg-[#0a0e1a] text-white', className)}
    >
      <form className="w-full max-w-sm flex flex-col gap-4">
        <h2 className="text-2xl font-bold mb-4">{title}</h2>

        {error && <div className="text-red-500 text-sm">{typeof error === 'string' ? error : 'An error occurred'}</div>}

        {children}

        {footer || (
          <>
            <div className="text-center text-sm mt-4 text-gray-400">
              Already have an account? Click{' '}
              <Link to="/" className="text-blue-400 hover:text-blue-300 font-bold">
                here
              </Link>{' '}
              to login.
            </div>

            <div className="text-center text-xs mt-8 text-gray-500">
              Space-Eyes, INC is a US based company and only conducts business with US allies.
            </div>
          </>
        )}
      </form>
    </div>
  );
};
